import { render, staticRenderFns } from "./UserNotification.vue?vue&type=template&id=3355ee12&scoped=true"
import script from "./UserNotification.vue?vue&type=script&lang=js"
export * from "./UserNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355ee12",
  null
  
)

export default component.exports